import { useStyletron } from "baseui";
import { StyledSvg } from "baseui/icon";
import React from "react";

export const HeavyCheckmarkIcon = (props: React.ComponentProps<typeof StyledSvg> & { $disabled: boolean }) => {
  const [_, $theme] = useStyletron();

  return (
    <StyledSvg viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.55545 13.9722L4.94434 10.3922L6.09267 9.2778L8.55545 11.6944L13.9064 6.38892L15.0554 7.52786L8.55545 13.9722Z"
        fill={props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : "currentcolor")}
      />
    </StyledSvg>
  );
};
